import React, { useState, useEffect } from 'react';
import './ViewProfile.css';
import './createadmin.css';
import './OneToOneReview.css';
import sortIcon from './images/sort.png';
import msortIcon from './images/msort.png'; // Reuse for mobile

const ViewProfile = () => {
  const [userData, setUserData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/user`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const data = await response.json();
      setUserData(Array.isArray(data) ? data : [data]);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // ✅ Auto search & reset when searchQuery changes
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const fetchSearchResults = async () => {
        const url = searchQuery
          ? `${process.env.REACT_APP_SERVER_IP}/api/admin/user?searchQuery=${searchQuery}`
          : `${process.env.REACT_APP_SERVER_IP}/api/admin/user`;

        try {
          const response = await fetch(url, {
            headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
          });
          const data = await response.json();
          setUserData(Array.isArray(data) ? data : [data]);
        } catch (error) {
          console.error('Error fetching search results:', error);
        }
      };

      fetchSearchResults();
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery]);

  const sortData = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }

    const sortedData = [...userData].sort((a, b) => {
      let valueA = a[key] || '';
      let valueB = b[key] || '';

      if (!isNaN(Date.parse(valueA)) && !isNaN(Date.parse(valueB))) {
        valueA = new Date(valueA);
        valueB = new Date(valueB);
        return direction === 'ascending' ? valueA - valueB : valueB - valueA;
      }

      if (!isNaN(valueA) && !isNaN(valueB)) {
        return direction === 'ascending' ? valueA - valueB : valueB - valueA;
      }

      valueA = valueA.toString().toLowerCase();
      valueB = valueB.toString().toLowerCase();
      return direction === 'ascending' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });

    setSortConfig({ key, direction });
    setUserData(sortedData);
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).replace(/ /g, '-');
  };

  return (
    <div className="contain">
      <main className="main-content">
      <div className="table-containerAdd">
 
        <div className="search-containerAdd">

        <h2 className="name">View All Members</h2>
          <input
            type="text"
            placeholder="Search User"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)} // ✅ updated
          />
        </div>


      
        {/* Desktop Table */}
        <div className="desktop-table">
          <table className="table-heading">
            <thead>
              <tr>
                {[{ key: 'sno', label: 'S.No' }, { key: 'firstName', label: 'Name' }, { key: 'company', label: 'Company' }, { key: 'occupation', label: 'Occupation' }, { key: 'number', label: 'Number' }, { key: 'email', label: 'Email' }, { key: 'date', label: 'Date' }, { key: 'collageName', label: 'Collage' }, { key: 'year', label: 'Year' }, { key: 'hlabc', label: 'HLABC' }, { key: 'universityName', label: 'University' }]
                  .map(({ key, label }) => (
                    <th key={key} onClick={() => sortData(key)}>
                      {label} <img src={sortIcon} alt="Sort" />
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {userData.length > 0 ? (
                userData.map((entry, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{entry.firstName} {entry.lastName}</td>
                    <td>{entry.company}</td>
                    <td>{entry.occupation}</td>
                    <td>{entry.number}</td>
                    <td>{entry.email}</td>
                    <td>{entry.date ? formatDate(entry.date) : ''}</td>
                    <td>{entry.collageName}</td>
                    <td>{entry.year}</td>
                    <td>{entry.hlabc}</td>
                    <td>{entry.universityName}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Mobile Scroll Table */}
        <div className="mobile-scroll-table-add">
          <div className="mobile-scroll-wrapper">
            <table>
              <tbody>
                <tr>
                  <th className="sticky-col">S.No</th>
                  {userData.map((_, i) => <td key={`sno-${i}`}>{i + 1}</td>)}
                </tr>
                <tr>
                  <th className="sticky-col">Name <img src={msortIcon} alt="Sort" className="sort-iconm" onClick={() => sortData('firstName')} /></th>
                  {userData.map((u, i) => <td key={`name-${i}`}>{u.firstName} {u.lastName}</td>)}
                </tr>
                <tr>
                  <th className="sticky-col">Company <img src={msortIcon} alt="Sort" className="sort-iconm" onClick={() => sortData('firstName')} /></th>
                  {userData.map((u, i) => <td key={`comp-${i}`}>{u.company}</td>)}
                </tr>
                <tr>
                  <th className="sticky-col">Occupation <img src={msortIcon} alt="Sort" className="sort-iconm" onClick={() => sortData('firstName')} /></th>
                  {userData.map((u, i) => <td key={`occ-${i}`}>{u.occupation}</td>)}
                </tr>
                <tr>
                  <th className="sticky-col">Number <img src={msortIcon} alt="Sort" className="sort-iconm" onClick={() => sortData('firstName')} /></th>
                  {userData.map((u, i) => <td key={`num-${i}`}>{u.number}</td>)}
                </tr>
                <tr>
                  <th className="sticky-col">Email <img src={msortIcon} alt="Sort" className="sort-iconm" onClick={() => sortData('firstName')} /></th>
                  {userData.map((u, i) => <td key={`email-${i}`}>{u.email}</td>)}
                </tr>
                <tr>
                  <th className="sticky-col">DOB <img src={msortIcon} alt="Sort" className="sort-iconm" onClick={() => sortData('firstName')} /></th>
                  {userData.map((u, i) => <td key={`dob-${i}`}>{u.date ? formatDate(u.date) : 'N/A'}</td>)}
                </tr>
                <tr>
                  <th className="sticky-col">Collage <img src={msortIcon} alt="Sort" className="sort-iconm" onClick={() => sortData('firstName')} /></th>
                  {userData.map((u, i) => <td key={`coll-${i}`}>{u.collageName || 'N/A'}</td>)}
                </tr>
                <tr>
                  <th className="sticky-col">Year <img src={msortIcon} alt="Sort" className="sort-iconm" onClick={() => sortData('firstName')} /></th>
                  {userData.map((u, i) => <td key={`year-${i}`}>{u.year || 'N/A'}</td>)}
                </tr>
                <tr>
                  <th className="sticky-col">HLABC <img src={msortIcon} alt="Sort" className="sort-iconm" onClick={() => sortData('firstName')} /></th>
                  {userData.map((u, i) => <td key={`hlabc-${i}`}>{u.hlabc}</td>)}
                </tr>
                <tr>
                  <th className="sticky-col">University <img src={msortIcon} alt="Sort" className="sort-iconm" onClick={() => sortData('firstName')} /></th>
                  {userData.map((u, i) => <td key={`uni-${i}`}>{u.universityName}</td>)}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </div>
      </main>
    </div>
  );
};

export default ViewProfile;
